import { consoleLoggingIntegration } from '@sentry/react'
import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

import System from 'system'

export default () => {
  if (process.env.NODE_ENV === 'production' && System.sentry?.enabled) {
    const {
      init,
      reactRouterV6BrowserTracingIntegration,
      replayIntegration,
      setUser,
      // https://docs.sentry.io/platforms/javascript/guides/react/
      // eslint-disable-next-line @typescript-eslint/no-require-imports
    } = require('@sentry/react')

    init({
      dsn: System.sentry.dns,
      release: System.version,

      ignoreErrors: [
        /^No error$/,
        /__show__deepen/,
        /_avast_submit/,
        /Access is denied/,
        /anonymous function: captureException/,
        /Blocked a frame with origin/,
        /can't redefine non-configurable property "userAgent"/,
        /change_ua/,
        /console is not defined/,
        /cordova/,
        /DataCloneError/,
        /Error: AccessDeny/,
        /event is not defined/,
        /Failed to fetch/, // Broken requests
        /Failed to update/, // Broken requests for service worker
        /feedConf/,
        /ibFindAllVideos/,
        /InvalidSignatureException/, // Incorrect time on the device
        /Load failed/,
        /Loading chunk/, // Broken requests
        /Loading CSS chunk/, // Broken requests
        /Maximum update depth exceeded/,
        /myGloFrameList/,
        /MyIPhoneApp/,
        /SecurityError/,
        /Signature not yet current/, // Incorrect time on the device
        /snapchat\.com/,
        /The node to be removed is not a child of this node/, // Broken requests
        /The security token included in the request is invalid/,
        /Unexpected token '<'/, // Broken requests
        /UnrecognizedClientException/,
        /vid_mate_check is not defined/,
        /win\.document\.body/,
        /window\._sharedData\.entry_data/,
        /window\.regainData/,
        /ztePageScrollModule/,
      ],
      integrations: [
        reactRouterV6BrowserTracingIntegration({
          createRoutesFromChildren,
          matchRoutes,
          useEffect,
          useLocation,
          useNavigationType,
        }),
        replayIntegration({
          blockAllMedia: false,
          maskAllInputs: false,
          maskAllText: false,
          networkDetailAllowUrls: [window.location.origin, /\.amazonaws\.com/, /\.sweatbits\.co/],
        }),
        // send console.log, console.warn, and console.error calls as logs to Sentry
        consoleLoggingIntegration({ levels: ['log', 'info', 'warn', 'error'] }),
      ],

      blockAllMedia: false,
      maskAllText: false,

      // Capture 100% of sessions with an error
      replaysOnErrorSampleRate: 0.1,
      // Capture Replay for 5% of all sessions,
      replaysSessionSampleRate: 0.05,

      tracesSampleRate: 1,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      // Careful with this, it can be a login blocker by CORS
      tracePropagationTargets: ['localhost'],

      // Enable logs to be sent to Sentry
      enableLogs: true,
    })

    // @todo You have to change this values or put them some where else
    // https://docs.sentry.io/platforms/javascript/?platform=browser#capturing-the-user
    setUser({
      id: 'unknown',
      avatar: '',
      email: 'anonymous',
      name: 'anonymous',
      username: 'anonymous',
    })
  }
}
